export const REQUIRED_INSURANCE_POLICY_TYPES = ['automobile_liability', 'motor_truck_cargo']
export const TRANSFIX_FLAGS_POLICY_TYPES = {
  TRANSFIX_AS_HOLDER: [
    'automobile_liability',
    'general_liability',
    'motor_truck_cargo',
    'workers_compensation',
    'dishonesty_bond',
  ],
  TRANSFIX_LISTED_AS_ADDITIONAL_INSURED: ['automobile_liability'],
  TRANSFIX_LISTED_AS_PAYEE: ['motor_truck_cargo'],
}
export const ARCHIVED_CERTS_LABEL = 'Archived Certs'
